var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useSelector } from "react-redux";
import moment from "moment";
import { addCommasWithoutEffectingDecimals } from "@domains/utils/numberMethods";
import CashFlow from "@frameworks/NCD/pages/ProductBouquet/Components/DetailsSidebar/Components/CashFlow";
import FixingTable from "@frameworks/NCD/pages/ProductBouquet/Components/DetailsSidebar/Components/FixingTable";
import React, { useMemo } from "react";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/DowloadData";
import { downloadFromBase64 } from "@domains/utils/downloadFromBase64";
var formatDate = function (date) {
    return date ? moment(date).format("DD MMM YY") : "-";
};
var formatCurrency = function (value) {
    return addCommasWithoutEffectingDecimals(Number(value).toFixed(2)) || "-";
};
var formatData = function (value, suffix) {
    //return value ? String(addCommas(value, true)) + " " + suffix : "NA";
    return value ? "".concat(String(value)).concat(suffix) : "NA";
};
var formatYesNo = function (val) {
    return val === "Listed" ? "Yes" : "No";
};
export var useAccordionProductDetails = function () {
    var _a = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), productDetails = _a.productDetails, watchListRequestPayload = _a.watchListRequestPayload, subCategoryId = _a.subCategoryId;
    var fixingDetails = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).fixingDetails;
    var apiData = useMemo(function () { return productDetails === null || productDetails === void 0 ? void 0 : productDetails.data; }, [productDetails]);
    var commonListedData = {
        label: "Listed",
        value: formatYesNo(apiData === null || apiData === void 0 ? void 0 : apiData.islisted),
        className: "txt-midnight-blue-shade2",
        valueClassName: "DMSanN_14_400",
    };
    var documentDownload = function (label, value, siblingComponent) { return (__assign({ label: label, value: value ? (React.createElement("div", { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, otcDi.productBouquet.getDownloadData({
                                isin_code: apiData === null || apiData === void 0 ? void 0 : apiData.isin_code,
                                tab_id: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.tab_id,
                                buy_sell_flag: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg,
                            })];
                        case 1:
                            res = _c.sent();
                            downloadFromBase64(res === null || res === void 0 ? void 0 : res.data, apiData === null || apiData === void 0 ? void 0 : apiData.file_name, (_b = (_a = apiData === null || apiData === void 0 ? void 0 : apiData.file_path) === null || _a === void 0 ? void 0 : _a.split(".")) === null || _b === void 0 ? void 0 : _b[1]);
                            return [2 /*return*/];
                    }
                });
            }); } }, "Download")) : ("-"), icon: value && (React.createElement("i", { className: "edel-icon-download-curve txt-han-blue d-flex align-items-center justify-content-center fs-25", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                var res;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, otcDi.productBouquet.getDownloadData({
                                isin_code: apiData === null || apiData === void 0 ? void 0 : apiData.isin_code,
                                tab_id: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.tab_id,
                                buy_sell_flag: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg,
                            })];
                        case 1:
                            res = _c.sent();
                            downloadFromBase64(res === null || res === void 0 ? void 0 : res.data, apiData === null || apiData === void 0 ? void 0 : apiData.file_name, (_b = (_a = apiData === null || apiData === void 0 ? void 0 : apiData.file_path) === null || _a === void 0 ? void 0 : _a.split(".")) === null || _b === void 0 ? void 0 : _b[1]);
                            return [2 /*return*/];
                    }
                });
            }); } })), className: "txt-han-blue" }, (siblingComponent && { siblingComponent: siblingComponent }))); };
    var getBondSections = function () {
        var _a, _b, _c;
        return [
            {
                section: "Scheme Details",
                icon: (React.createElement("i", { className: "edel-icon-fund-document d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Face Value",
                        value: formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.face_value),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Instrument Type",
                        value: apiData === null || apiData === void 0 ? void 0 : apiData.instrument_type,
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Coupon",
                        value: formatData(apiData === null || apiData === void 0 ? void 0 : apiData.coupon_rate, "%"),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Tenure",
                        value: String((_a = apiData === null || apiData === void 0 ? void 0 : apiData.tenure) !== null && _a !== void 0 ? _a : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Remaining Period",
                        value: String((_b = apiData === null || apiData === void 0 ? void 0 : apiData.remain_period_short) !== null && _b !== void 0 ? _b : "-"),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Max. ".concat(watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? "Buy"
                            : "Sell", " Price"),
                        value: "\u20B9".concat(watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.buy_price_max)
                            : formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.max_sell_price)),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Min. ".concat(watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? "Buy"
                            : "Sell", " Price"),
                        value: "\u20B9".concat(watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.buy_price_min)
                            : formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.min_sell_price)),
                        valueClassName: "RobotoR_14_400",
                    },
                    // { label: "Perpetual", value: "-" },
                ],
            },
            {
                section: "Bond Quality",
                icon: (React.createElement("i", { className: "edel-icon-debt-quality d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Security Type",
                        value: String((_c = apiData === null || apiData === void 0 ? void 0 : apiData.issecured) !== null && _c !== void 0 ? _c : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    commonListedData,
                ],
            },
            {
                section: "Documents",
                icon: (React.createElement("i", { className: "edel-icon-page-copy d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    documentDownload("Product Note", apiData === null || apiData === void 0 ? void 0 : apiData.file_name, React.createElement(CashFlow, null)),
                ],
            },
        ];
    };
    var getNcdSections = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return [
            {
                section: "Other Details",
                icon: (React.createElement("i", { className: "edel-icon-fund-document d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Min. Sell Price (₹)",
                        value: watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.buy_price_min)
                            : formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.min_sell_price),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Payout Frequency",
                        value: String((_a = apiData === null || apiData === void 0 ? void 0 : apiData.interest_frequency) !== null && _a !== void 0 ? _a : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Available Qty.",
                        value: watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? apiData === null || apiData === void 0 ? void 0 : apiData.virtual_buy_qty
                            : apiData === null || apiData === void 0 ? void 0 : apiData.avl_qty,
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Depository",
                        value: String((_b = apiData === null || apiData === void 0 ? void 0 : apiData.depository_type_name) !== null && _b !== void 0 ? _b : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Residual Tenure",
                        value: String((_c = apiData === null || apiData === void 0 ? void 0 : apiData.residual_tenor) !== null && _c !== void 0 ? _c : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Price Validity",
                        value: formatDate(apiData === null || apiData === void 0 ? void 0 : apiData.price_valid_till),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Issuance Date",
                        value: formatDate(apiData === null || apiData === void 0 ? void 0 : apiData.issuance_date),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Risk Category",
                        value: String((_d = apiData === null || apiData === void 0 ? void 0 : apiData.risk_name) !== null && _d !== void 0 ? _d : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Rating History",
                        value: String((_e = apiData === null || apiData === void 0 ? void 0 : apiData.prev_rating) !== null && _e !== void 0 ? _e : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Accrued Interest",
                        value: String((_f = apiData === null || apiData === void 0 ? void 0 : apiData.accrued_interest) !== null && _f !== void 0 ? _f : "-"),
                        valueClassName: "RobotoR_14_400",
                    },
                ],
            },
            {
                section: "Bond Quality",
                icon: (React.createElement("i", { className: "edel-icon-debt-quality d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Rating",
                        value: String((_g = apiData === null || apiData === void 0 ? void 0 : apiData.rating) !== null && _g !== void 0 ? _g : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Security Type",
                        value: String((_h = apiData === null || apiData === void 0 ? void 0 : apiData.issecured) !== null && _h !== void 0 ? _h : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    commonListedData,
                    {
                        label: "Stock Format",
                        value: String((_j = apiData === null || apiData === void 0 ? void 0 : apiData.stock_format) !== null && _j !== void 0 ? _j : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                ],
            },
            {
                section: "Documents",
                icon: (React.createElement("i", { className: "edel-icon-page-copy d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [documentDownload("Product Note", apiData === null || apiData === void 0 ? void 0 : apiData.file_name, React.createElement(React.Fragment, null))],
            },
        ];
    };
    var getStructuredProductSections = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        return [
            {
                section: "Scheme Details",
                icon: (React.createElement("i", { className: "edel-icon-fund-document d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Face Value",
                        value: formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.face_value),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Quantity",
                        value: watchListRequestPayload.buysellflg === EBuySellFlag.BUY
                            ? apiData === null || apiData === void 0 ? void 0 : apiData.virtual_buy_qty
                            : apiData === null || apiData === void 0 ? void 0 : apiData.avl_qty,
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Coupon",
                        value: formatData(apiData === null || apiData === void 0 ? void 0 : apiData.coupon_rate, "%"),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Product",
                        value: String((_a = apiData === null || apiData === void 0 ? void 0 : apiData.product_name) !== null && _a !== void 0 ? _a : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Residual Maturity",
                        value: (_b = apiData === null || apiData === void 0 ? void 0 : apiData.residual_tenor) !== null && _b !== void 0 ? _b : "-",
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Maturity Value",
                        value: formatCurrency(apiData === null || apiData === void 0 ? void 0 : apiData.maturity_value),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Price Validity",
                        value: formatDate(apiData === null || apiData === void 0 ? void 0 : apiData.price_valid_till),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Revenue (%)",
                        value: String((_c = apiData === null || apiData === void 0 ? void 0 : apiData.revenue_percentage) !== null && _c !== void 0 ? _c : "-"),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Coupon Scenario",
                        value: String((_d = apiData === null || apiData === void 0 ? void 0 : apiData.coupon_scenario) !== null && _d !== void 0 ? _d : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                ],
            },
            {
                section: "Bond Quality",
                icon: (React.createElement("i", { className: "edel-icon-debt-quality d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Rating",
                        value: String((_e = apiData === null || apiData === void 0 ? void 0 : apiData.rating) !== null && _e !== void 0 ? _e : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Security Type",
                        value: String((_f = apiData === null || apiData === void 0 ? void 0 : apiData.issecured) !== null && _f !== void 0 ? _f : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    commonListedData,
                ],
            },
            {
                section: "Other Details",
                icon: (React.createElement("i", { className: "edel-icon-other-detail d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Stock Format",
                        value: String((_g = apiData === null || apiData === void 0 ? void 0 : apiData.stock_format) !== null && _g !== void 0 ? _g : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Market Type",
                        value: String((_h = apiData === null || apiData === void 0 ? void 0 : apiData.market_type_name) !== null && _h !== void 0 ? _h : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Entity",
                        value: String((_j = apiData === null || apiData === void 0 ? void 0 : apiData.entity_name) !== null && _j !== void 0 ? _j : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Depository Type",
                        value: String((_k = apiData === null || apiData === void 0 ? void 0 : apiData.depository_type_name) !== null && _k !== void 0 ? _k : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Price Validity",
                        value: formatDate(apiData === null || apiData === void 0 ? void 0 : apiData.price_valid_till),
                        valueClassName: "RobotoR_14_400",
                    },
                    {
                        label: "Risk Category",
                        value: String((_l = apiData === null || apiData === void 0 ? void 0 : apiData.risk_name) !== null && _l !== void 0 ? _l : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                    {
                        label: "Underlying Index",
                        value: String((_m = apiData === null || apiData === void 0 ? void 0 : apiData.underlying) !== null && _m !== void 0 ? _m : "-"),
                        valueClassName: "DMSanN_14_400",
                    },
                ],
            },
            {
                section: "Level",
                icon: (React.createElement("i", { className: "edel-icon-level d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [
                    {
                        label: "Average Initial Fixing Level",
                        value: String((_q = (_p = (_o = fixingDetails === null || fixingDetails === void 0 ? void 0 : fixingDetails.data) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.avg_fixing_level) !== null && _q !== void 0 ? _q : "-"),
                        siblingComponent: React.createElement(FixingTable, null),
                    },
                ],
            },
            {
                section: "Documents",
                icon: (React.createElement("i", { className: "edel-icon-page-copy d-flex align-items-center justify-content-between txt_light-lavender-blue fs-24" })),
                data: [documentDownload("Prospectus", apiData === null || apiData === void 0 ? void 0 : apiData.file_name)],
            },
        ];
    };
    switch (String(subCategoryId)) {
        case ESubProductIds.Bonds:
            return getBondSections();
        case ESubProductIds.NCD:
            return getNcdSections();
        case ESubProductIds.StructuredProducts:
            return getStructuredProductSections();
        case ESubProductIds.UnlistedShares:
            return [];
        default:
            return [];
    }
};
